const properties = new Map();

function set(key, value) {
  // Normalizing boolean in case of a kill switch
  if (value === 'true' || value === 'false') {
    // eslint-disable-next-line no-param-reassign
    value = value === 'true';
  }
  properties.set(key, value);
}

function load(newProperties) {
  if (newProperties) {
    Object.keys(newProperties).forEach(key => set(key, newProperties[key]));
  }
}

function get(key) {
  return properties.get(key);
}

module.exports = {
  load,
  get,
  set,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/Properties.js